module.exports = __webpack_public_path__ + "static/img/VE.20f26397.png";